import Snackbar, { SnackbarOrigin } from '@mui/material/Snackbar';

export { Snackbar, SnackbarOrigin };
